<template>
  <div class="mdc-snackbar"
       aria-live="assertive"
       aria-atomic="true"
       aria-hidden="true">
    <div class="mdc-snackbar__text"></div>
    <div class="mdc-snackbar__action-wrapper">
      <button type="button" class="mdc-snackbar__action-button"></button>
    </div>
  </div>
</template>

<script>
  import { MDCSnackbar } from '@material/snackbar/dist/mdc.snackbar.min';

  export default {
    name: 'snackbar',

    mounted() {
      const snackbar = new MDCSnackbar(this.$el);

      this.$root.$on('show::snackbar', (options) => {
        snackbar.show(options);
      });
    },

    destroyed() {
      this.$root.$off('show::snackbar');
    },
  };
</script>

<style lang="scss">
  .mdc-snackbar {
    .mdc-snackbar__action-wrapper>button.mdc-snackbar__action-button {
      color: #00c896;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Snackbar.vue